import { Control, Controller } from 'react-hook-form';
import { ImageFolderEnum } from '@/models/CkEditor';
import { HtmlPreview } from '@/components/ui/custom/dataDisplay/HtmlPreview';
import Text from '@/components/ui/custom/dataDisplay/Text';
import MyCkeditor from '../editor/MyCkeditor';

interface BioProps {
  bio?: string;
  isEdit: boolean;
  setHasChanges: (value: boolean) => void;
  control: Control<any>;
  name: string;
}

export default function ProfileBio({
  bio,
  isEdit,
  setHasChanges,
  control,
  name,
}: BioProps) {
  return (
    <div
      data-testid="bio"
      className="flex flex-col w-full gap-1 text-justify min-h-[250px] justify-self-start grow-0 lg:max-w-[500px] bg-base-100 border border-neutral/20 rounded-2xl p-2.5"
    >
      <Text
        text="Bio"
        format="rubik-500"
        className="text-accent text-18 self-start"
      />

      {!isEdit ? (
        <HtmlPreview className="w-full h-full" html={bio || `¯\\_(ツ)_/¯`} />
      ) : (
        <div
          className="w-full lg:w-[95%] lg:max-w-[60vw] xl:max-w-[68vw] "
          data-testid="bioEditor"
        >
          <Controller
            control={control}
            name={name}
            render={({ field: { onChange } }) => (
              <MyCkeditor
                content={bio || ''}
                testId="ckBioEditor"
                disabled={!isEdit}
                folder={ImageFolderEnum.BIO}
                handleContentChange={value => {
                  onChange(value);
                  setHasChanges(true);
                }}
              />
            )}
          />
        </div>
      )}
    </div>
  );
}
